import { render, staticRenderFns } from "./add-coupon-vivaincontri.vue?vue&type=template&id=9a8d2572&"
import script from "./add-coupon-vivaincontri.vue?vue&type=script&lang=js&"
export * from "./add-coupon-vivaincontri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a8d2572')) {
      api.createRecord('9a8d2572', component.options)
    } else {
      api.reload('9a8d2572', component.options)
    }
    module.hot.accept("./add-coupon-vivaincontri.vue?vue&type=template&id=9a8d2572&", function () {
      api.rerender('9a8d2572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/svg/add-coupon-vivaincontri.vue"
export default component.exports